var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0332 4.00781H17.9668C18.1387 4.00781 18.2246 4.07812 18.2246 4.21875V22.7812C18.2246 22.9219 18.1387 22.9922 17.9668 22.9922H16.0332C15.8613 22.9922 15.7754 22.9219 15.7754 22.7812V4.21875C15.7754 4.07812 15.8613 4.00781 16.0332 4.00781Z",
    fill: "#0FA958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 12.498H27.8281C28 12.498 28.0859 12.5684 28.0859 12.709V14.291C28.0859 14.4316 28 14.502 27.8281 14.502H6.17188C6 14.502 5.91406 14.4316 5.91406 14.291V12.709C5.91406 12.5684 6 12.498 6.17188 12.498Z",
    fill: "#0FA958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.36fe97696d231db5acadf295544403ce.svg";
export { ForwardRef as ReactComponent };